import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { submitEnquiryApi } from '../api/allApi';

export const submitEnquiry = createAsyncThunk(
    'enquiry/submitEnquiry',
    async (payload, { rejectWithValue }) => {
        try {
            return await submitEnquiryApi(payload);
        } catch (err) {
            return rejectWithValue(err?.response?.data?.message || 'Failed to submit enquiry');
        }
    }
);

const enquirySlice = createSlice({
    name: 'enquiry',
    initialState: { submitLoading: false, success: false, error: null },
    reducers: {
        resetEnquiryState: (state) => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(submitEnquiry.pending, (state) => {
                state.submitLoading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(submitEnquiry.fulfilled, (state) => {
                state.submitLoading = false;
                state.success = true;
            })
            .addCase(submitEnquiry.rejected, (state, action) => {
                state.submitLoading = false;
                state.error = action.payload;
            });
    },
});

export const { resetEnquiryState } = enquirySlice.actions;
export default enquirySlice.reducer;